<template>
    <div class="loading">
        <div class="circular-loader"></div>
    </div>
</template>

<script>
    export default {
        name: "LoadingPage",
        created() {
            this.$scrollTo(`body`, 50);
        }
    }
</script>

<style lang="scss" scoped>
    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        color: #fff;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
    }

    .circular-loader {
        margin: 0 auto;
        width: 60px;
        height: 60px;
        position: relative;
        border-radius: 50%;
        border: 4px solid #10284A;
        border-bottom-color: rgba(0, 0, 0, 0) !important;
        animation: sk-rotate .8s infinite linear both;
    }

    @-webkit-keyframes sk-rotate {
        0% {
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes sk-rotate {
        0% {
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -ms-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
            -moz-transform: rotate(360deg);
            -ms-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }
</style>